export default __webpack_public_path__ + "static/media/icon3.c1784ea2.png";